import React, { useRef, useState } from "react";

import Images from "../../../asset/Images";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { useLocation } from "react-router-dom";
import { toWords } from "number-to-words";
import QuotationFooter from "../quotationScr/QuotationFooter";
import moment from "moment";
import QuotationHeader from "../quotationScr/QuotationHeader";

const ProformaInvoiceBill = () => {
  const { state } = useLocation();
  console.log("state", state);

  const invoiceRef = useRef();
  const [printMode, setPrintMode] = useState("plain");

  let totalAmount = 0;
  let quantity = 0;
  let totalItems = 0;
  let totalPrice = 0;

  const amount = state?.appendList?.reduce((total, item) => {
    const qty = Number(item?.qty || 0);
    const price = Number(item?.price || 0);
    return total + qty * price;
  }, 0);

  const discount = Number(state?.discount || 0);
  const gstRate = Number(state?.gstPercentage || 0);

  const totalDiscountedAmount = Number(amount) - Number(discount);

  const gstAmount = (Number(totalDiscountedAmount) * Number(gstRate)) / 100;

  const downloadPDF = async (mode) => {
    // Get the wrapper element
    const wrapper = document.getElementById("wrapper");

    // Clone the wrapper to avoid modifying the original DOM
    const clone = wrapper.cloneNode(true);

    // Remove header and footer if mode is 'letterpad'
    if (mode === "letterpad") {
      const clonedHeader = clone.querySelector("#header");
      const clonedFooter = clone.querySelector("#footer");
      if (clonedHeader) clonedHeader.remove();
      if (clonedFooter) clonedFooter.remove();

      clone.style.paddingTop = "30mm";
    }

    // Apply custom styles to avoid breaking inside tables (page break behavior)
    clone.querySelectorAll("table, tr").forEach((el) => {
      el.style.pageBreakInside = "avoid"; // CSS to avoid page break inside
      el.style.breakInside = "avoid"; // Another CSS to avoid break
    });

    // Set style for cloned element to hide off-screen
    clone.style.position = "absolute";
    clone.style.left = "-9999px";
    document.body.appendChild(clone);

    // Create canvas from the clone of the DOM element
    const canvas = await html2canvas(clone, { scale: 1, useCORS: true });

    // Convert canvas to image data URL (PNG format)
    const imgData = canvas.toDataURL("image/png");

    // Initialize jsPDF for generating the PDF
    const pdf = new jsPDF("p", "mm", [210, 400]);
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Get image properties for aspect ratio scaling
    const imgProps = pdf.getImageProperties(imgData);
    const imgHeight = (imgProps.height * pageWidth) / imgProps.width;

    let heightLeft = imgHeight; // Remaining height for the image
    let position = 0; // Initial position of the image on the first page

    // Add the first page with the image
    pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
    heightLeft -= pageHeight;

    // Loop to handle multiple pages if content overflows
    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage(); // Create a new page
      pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight); // Add image to new page
      heightLeft -= pageHeight;
    }

    // Save the PDF with the specified filename
    pdf.save("proforma_invoice.pdf");

    // Remove the cloned wrapper from the DOM after the PDF is generated
    document.body.removeChild(clone);
  };

  return (
    <>
      <section className="invoice_main_section">
        <div id="wrapper">
          <header id="header">
            <QuotationHeader content={state?.branchDetailsName} />
          </header>

          <main className="my-2  p-0" id="content">
            <div className="invoice-top-bar">
              <div className="left"></div>
              <div className="center" style={{ fontSize: "18px" }}>
                <b>PROFORMA INVOICE</b>
              </div>
              <div className="right">Original</div>
            </div>
            <div className="header-section">
              <div className="left-section company-details">
                <div className="company-name">
                  {state?.branchDetailsName || ""}
                </div>
                <p className="invoice_address_part my-0">
                  {/* <b>
                    {" "}
                    {`${state?.branchDetailsNo || ""} , ${state?.branchDetailsStreet || ""
                      } ,${state?.branchDetailsLocality || ""} ,${state?.branchDetailsCity || ""
                      } - ${state?.branchDetailsPincode || ""}, Tamilnadu`}{" "}
                  </b> */}

                  {[
                    "SRI LAKSHMI BUILD CRAFT",
                    "Sri Lakshmi Build Craft",
                    "sri lakshmi build craft",
                  ].includes(state?.branchDetailsName) ? (
                    <>
                      <b>
                        No.714-A , Spencer Plaza,Phase-II,7th Floor , Anna Salai , Chennai - 6000002 ,TamilNadu
                      </b>
                    </>
                  ) : (
                    <>
                      <b>
                        No.10/50 , 2nd Palla Street , Vyasarpadi , Chennai - 600039 ,TamilNadu
                      </b>
                    </>
                  )}

                </p>
                <table>
                  <tbody>
                    <tr>
                      <td className="invoice_sub_title">GST NO </td>
                      <td className="invoice_address_part">
                        {" "}
                        <b> : </b> {state?.gstIn || ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="invoice_sub_title">CONTACT</td>
                      <td className="invoice_address_part">
                        {" "}
                        <b> : </b> {state?.branchDetailsPhoneNo || ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="invoice_sub_title">MSME NO</td>
                      <td className="invoice_address_part">
                        {[
                          "SRI LAKSHMI BUILD CRAFT",
                          "Sri Lakshmi Build Craft",
                          "sri lakshmi build craft",
                        ].includes(state?.branchDetailsName) ? (
                          <>
                            {" "}
                            <b> : </b>UDYAM-TN-02-0053319
                          </>
                        ) : (
                          <>
                            {" "}
                            <b> : </b>UDYAM-TN-02-0259733
                          </>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="invoice_sub_title">E-MAIL</td>
                      <td>
                        {[
                          "SRI LAKSHMI BUILD CRAFT",
                          "Sri Lakshmi Build Craft",
                          "sri lakshmi build craft",
                        ].includes(state?.branchDetailsName) ? (
                          <>
                            <b> : </b>
                            <a
                              href="mailto:srilakshmibuildcraft@gmail.com"
                              target="_blank"
                            >
                              srilakshmibuildcraft@gmail.com
                            </a>
                          </>
                        ) : (
                          <>
                            <b> : </b>
                            <a
                              href="mailto:rashispacesolution@gmail.com"
                              target="_blank"
                            >
                              rashispacesolution@gmail.com
                            </a>
                          </>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="invoice_sub_title">WEBSITE</td>
                      <td>
                        {[
                          "SRI LAKSHMI BUILD CRAFT",
                          "Sri Lakshmi Build Craft",
                          "sri lakshmi build craft",
                        ].includes(state?.branchDetailsName) ? (
                          <>
                            <b> : </b>
                            <a
                              href="https://www.srilakshmibuildcraft.com"
                              target="_blank"
                            >
                              www.srilakshmibuildcraft.com
                            </a>
                          </>
                        ) : (
                          <>
                            <b> : </b>
                            <a
                              href="https://www.rashispacesolution.com"
                              target="_blank"
                            >
                              www.rashispacesolution.com
                            </a>
                          </>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="right-section">
                <p className="my-0">
                  <span className="invoice_sub_title">PI NO : </span>{" "}
                  <span className="invoice_address_part">
                    {" "}
                    {state?.performaInvoiceNo || ""}
                  </span>
                </p>
                <p className="my-0">
                  <span className="invoice_sub_title"> Date : </span>
                  <span className="invoice_address_part">
                    {state?.date
                      ? moment(state?.date).format("DD-MM-YYYY")
                      : ""}
                  </span>
                </p>
                <p className="my-0">
                  <span className="invoice_sub_title">P.O.NO : </span>
                  <span className="invoice_address_part">
                    {state?.poNo || ""}{" "}
                  </span>
                </p>
                <p className="my-0">
                  <span className="invoice_sub_title">Cust Order Date : </span>{" "}
                  <span className="invoice_address_part">
                    {state?.cusOrderDate
                      ? moment(state?.cusOrderDate).format("DD-MM-YYYY")
                      : ""}
                  </span>
                </p>
                <p className="my-0">
                  <span className="invoice_sub_title">Reference : </span>{" "}
                  <span className="invoice_address_part">
                    {state?.reference || ""}{" "}
                  </span>
                </p>
              </div>
            </div>
            <div className="invoice-billing-block px-2">
              <table>
                <tr>
                  <td className="invoice_sub_title">BILLING ADDRESS</td>
                  <td className="invoice_address_part">
                    <b> : </b>
                    {`${state?.customerName || ""}, ${state?.doorNo || ""},  ${state?.street || ""
                      } , ${state?.locality || ""} , ${state?.city || ""}, ${state?.state || ""
                      }- ${state?.pincode}`}
                  </td>
                </tr>
                <tr>
                  <td className="invoice_sub_title">CONTACT NO</td>
                  <td className="invoice_address_part">
                    <b> : </b> {state?.mobileNo || ""}
                  </td>
                </tr>
                <tr>
                  <td className="invoice_sub_title">CUSTOMER GST NO</td>
                  <td className="invoice_address_part">
                    <b> : </b> {state?.customerGst}
                  </td>
                </tr>
              </table>
            </div>
            <table className="invoice-table">
              <thead>
                <tr>
                  <th>SNo</th>
                  <th>NAME OF THE PRODUCT/SERVICES</th>
                  <th>HSN/SAC</th>
                  <th>QTY</th>
                  <th>UNIT</th>
                  <th>RATE</th>
                  <th>AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {state &&
                  state?.appendList?.map((data, i) => {
                    totalAmount =
                      Number(totalAmount) +
                      Number(data?.qty || 0) * Number(data?.price || 0);
                    quantity = Number(quantity || 0) + Number(data?.qty || 0);
                    totalItems = Number(totalItems || 0) + 1;
                    totalPrice =
                      Number(data?.price || 0) * Number(data?.qty || 0);

                    return (
                      <>
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{data?.description || "-"}</td>
                          <td>{data?.hsnCd || "-"}</td>
                          <td>{data?.qty || "-"}</td>
                          <td>{data?.percentage || "-"}</td>
                          <td>{data?.price || "-"}</td>

                          <td>{totalPrice || "0"}</td>
                        </tr>
                      </>
                    );
                  })}

                <tr className="subtotal-row">
                  <td colspan="5" style={{ border: "none", textAlign: "left" }}>
                    {" "}
                    Total Items / Qty :{totalItems || 0}&nbsp;/&nbsp;
                    {quantity || 0}
                  </td>
                  <td></td>
                  <td style={{ textAlign: "center" }}>  ₹{totalAmount.toLocaleString('en-IN')}</td>
                  {/* <td style={{ textAlign: "center" }}>₹{totalAmount}</td> */}
                </tr>
              </tbody>
            </table>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid rgba(0, 0, 0, 0.514)",
              }}
            >
              <tbody>
                <tr>
                  <td className="invoice_bank_title">
                    {" "}
                    <b> Account Holder Name</b>
                  </td>
                  <td
                    style={{ borderRight: "1px solid black" }}
                    className="invoice_bank_details"
                  >
                    : {state?.currentAccHoldersName || ""}
                  </td>
                  <td rowSpan="6">
                    <div>
                      <p className="invoice_total_amt">
                        <span>Taxable Amount</span>
                        {/* <span> {totalAmount || 0}</span> */}
                        <span>₹{(totalAmount || 0).toLocaleString('en-IN')}</span>

                      </p>
                      {state?.discount == 0 ||
                        state?.discount == "" ||
                        state?.discount == null ? null : (
                        <p className="invoice_total_amt">
                          <span>Discount Amount</span>
                          <span>{state?.discount}</span>
                        </p>
                      )}
                      {state?.roundOff == 0 ||
                        state?.roundOff == "" ||
                        state?.roundOff == null ? null : (
                        <p className="invoice_total_amt">
                          <span>Round Off</span>
                          <span>{state?.roundOff}</span>
                        </p>
                      )}
                      <p className="invoice_total_amt">
                        <span>Total GST </span>
                        {/* <span>{gstAmount || 0}</span> */}
                        <span>₹{(gstAmount || 0).toLocaleString('en-IN')}</span>

                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="invoice_bank_title">
                    {" "}
                    <b>Bank Name</b>
                  </td>
                  <td
                    style={{ borderRight: "1px solid black" }}
                    className="invoice_bank_details"
                  >
                    : {state?.bankName || ""}
                  </td>
                </tr>
                <tr>
                  <td className="invoice_bank_title">
                    {" "}
                    <b>A/C No</b>
                  </td>
                  <td
                    style={{ borderRight: "1px solid black" }}
                    className="invoice_bank_details"
                  >
                    : {state?.accNo || ""}
                  </td>
                </tr>
                <tr>
                  <td className="invoice_bank_title">
                    {" "}
                    <b>IFSC Code</b>
                  </td>
                  <td
                    style={{ borderRight: "1px solid black" }}
                    className="invoice_bank_details"
                  >
                    : {state?.ifscCode || ""}
                  </td>
                </tr>
                <tr>
                  <td className="invoice_bank_title">
                    {" "}
                    <b>Branch & Type</b>
                  </td>
                  <td
                    style={{ borderRight: "1px solid black" }}
                    className="invoice_bank_details"
                  >
                    : {state?.branch || ""}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" style={{ border: "1px solid black" }}>
                    {" "}
                    <b className="invoice_bank_title">
                      <i>Total Amount :</i>
                    </b>{" "}
                    <i>
                      RUPEES {toWords(state?.totalAmount || 0).toUpperCase()}{" "}
                      ONLY
                    </i>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan="2" style={{ border: "1px solid black" }}>
                    {" "}
                    <b>Delaration:</b>{" "}
                    <span className="invoice_declaration">
                      We declare that this invoice shows the actual price of the
                      goods / services described and that all particulars are
                      true and correct
                    </span>
                  </td>
                  <td
                    style={{
                      backgroundColor: "#d3d3d3",
                      border: "1px solid black",
                      padding: "0px",
                    }}
                  >
                    {" "}
                    <p className="invoice_total_amt">
                      <span>Grand Total</span>
                      {/* <span>{state?.totalAmount || 0}</span> */}
                      <span>₹{(state?.totalAmount || 0).toLocaleString('en-IN')}</span>

                      {/* <span> {totalAmount}</span> */}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="invoice-footer">
              <div className="termscondionblock px-1">
                <div className="col-9 p-0">
                  <div className="terms">
                    <b>Terms & Conditions :</b>

                    <p className="quotation_invoice_list">
                      1.Goods once sold will not be taken back or replace at any
                      cost.
                    </p>
                    <p className="quotation_invoice_list">
                      2.Payments to be made as per agreed payment terms Bank
                      Details attached for your Information.
                    </p>
                    <p className="quotation_invoice_list">
                      3.Any additional work will charge additionally, seperate PO or Agreed estimate or Customer approval required to proceed additional work.
                    </p>
                    <p className="quotation_invoice_list">
                      4.Electrical source, drinking water, safe storing place customer scope @ free of cost
                    </p>
                    <p className="quotation_invoice_list">
                      5.Estimate / Proforma invoice  is approximate only. Final billing / Tax invoice will be done after completion of work, based on actuals.
                    </p>
                    <p className="quotation_invoice_list">
                      6.Schedule of work as per mutually agreed terms & subjected to site conditions
                    </p>
                    <p className="quotation_invoice_list">
                      7.We are using branded materials in our work, so we are giving Limited company warranty for our executed work.
                    </p>
                    <p className="quotation_invoice_list">
                      8.cost includes materials, labour & material handling only.{" "}
                    </p>
                  </div>
                </div>

                <div className="col-3 d-flex flex-column px-1 mt-1">
                  <p
                    style={{ textAlign: "right", fontSize: "14px" }}
                    className="mb-5"
                  >
                    For,{" "}
                    {state?.branchDetailsName
                      ? state?.branchDetailsName.toUpperCase()
                      : ""}
                  </p>
                  <p
                    style={{ textAlign: "right", fontSize: "14px" }}
                    className="mt-3"
                  >
                    (Authorized Signature)
                  </p>
                </div>
              </div>
            </div>
          </main>
          <footer id="footer">
            <QuotationFooter content={state?.branchDetailsName} />
          </footer>

          {/* <p className="text-center">
            <i>
              Developed By{" "}
              <span style={{ color: "blue", opacity: "0.3" }}>
                www.2kvirtualworld.com
              </span>
            </i>
          </p> */}
        </div>
        <div className="d-flex justify-content-center my-3 gap-1">
          <button
            onClick={() => downloadPDF("letterpad")}
            className="download_btn"
          >
            Without Letter Pad
          </button>
          <button onClick={() => downloadPDF("plain")} className="download_btn">
            With Letter Pad
          </button>
        </div>
      </section>
    </>
  );
};

export default ProformaInvoiceBill;
